import script from "./ComparePage.vue?vue&type=script&lang=ts&setup=true"
export * from "./ComparePage.vue?vue&type=script&lang=ts&setup=true"

import "./ComparePage.vue?vue&type=style&index=0&id=65bfef16&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65bfef16"]])

export default __exports__